module.exports = __webpack_public_path__ + "static/media/icon-list.1c62691c.svg";